export default {
  SET_ISSUER_AFFILIATES(state, data) {
    state.issuerAffiliatesList = data.data;
    state.totalCount = data.totalCount || data.totalItems;
  },
  SET_ISSUER_AFFILIATE(state, data) {
    state.activeIssuerAffiliate = data;
  },
};
